import { OperationRequestData } from "../../data/operationRequestData";
import { clientTime } from "../../utilities/index";
import { TemplateData } from "../../data/templateData";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { dateFormat } from "../../utilities/parseHelper";
import { getAmericanDate } from "../../utilities/parseHelper";
import { Http } from "./http";

/**Запросы к методам провередния операций дбо*/
export class TemplatesApi {
  /**
   * Получение шаблона операции.
   * @param id Внутренний ИД шаблона.
   * @returns>Данные шаблона.
   * */
  public static async getTemplateAsync(
    id: number
  ): Promise<OperationRequestData> {
    // получаем подробные данные конкретного уведомления.
    const respData = await Http.get(
      `WebClient/GetTemplate?templateId=${id}&clientTime=${clientTime()}&typeSource=0`
    );
    // парсим данные
    return new OperationRequestData(respData?.data);
  }

  /**
   * Получение списка шаблонов.
   * @returns Список шаблонов.
   */
  public static async getTemplatesAsync(
    take: number = 1000,
    skip: number = 0
  ): Promise<Array<TemplateData>> {
    const templatesList: Array<TemplateData> = [];

    const respData = await Http.get(
      `WebClient/GetTemplates?take=${take}&skip=${skip}&clientTime=${clientTime()}&typeSource=0`
    );
    const templates = respData?.data;

    if (templates != null) {
      templates.forEach((templates: any) => {
        templatesList.push(new TemplateData(templates));
      });
    }
    return templatesList;
  }

  /**
   * Удаление шаблона.
   * @param operationId ИД шаблона.
   * @returns>Задача.*/
  public static async deleteTemplateAsync(templateId: number): Promise<void> {
    await Http.get(
      `WebClient/DeleteTemplate?templateId=${templateId}&clientTime=${clientTime()}&typeSource=0`
    );
  }

  /**
   * Сохранение шаблона по операции.
   * @param operationId ИД операции.
   * @param templateName Наименование шаблона.
   * @returns>Задача.*/
  public static async editTemplateAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await Http.operationSendAsync(
      "WebClient/EditTemplate",
      ord
    );

    return new OperationRequestData(respData.data);
  }

  /**
   * Сохранение шаблона по операции.
   * @param operationId ИД операции.
   * @param templateName Наименование шаблона.
   * @returns>Задача.*/
  public static async saveTemplateByOperationAsync(
    ord: OperationRequestData
  ): Promise<OperationRequestData> {
    // Выполняем запрос.
    const respData = await Http.operationSendAsync(
      "WebClient/SaveTemplate",
      ord
    );

    return new OperationRequestData(respData.data);
  }
}
